import { Injectable } from '@angular/core';
import {AngularFireAuth} from "angularfire2/auth";
import {User} from "firebase/app";
import { auth }  from  "firebase/app";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class AuthAdminService {

  user$ = new BehaviorSubject<User>(null);

  constructor( public afAuth : AngularFireAuth) {}

  async login(email: string, password: string) {
    await this.afAuth.auth.setPersistence(auth.Auth.Persistence.SESSION);
    return this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then( userCredentials => this.user$.next(userCredentials.user))
      .catch( error => {
        if (error.code === 'auth/wrong-password') {
          console.error('Wrong Password');
        } else {
          //handle other
          console.error(error.message)
        }
        throw error;
      })
  }

  logout() {
    return this.afAuth.auth.signOut().then( ()=> this.user$.next(null));
  }

  isLoggedIn(): Promise<boolean> {
    let promise = new Promise<boolean>(
      (resolve) => {

        this.user$.subscribe((user) => {
            resolve( !!(user && user.uid) )
        })
      }
    );
    return promise;
  }

  getLoggedUser(): User {
    return this.afAuth.auth.currentUser;
  }


}



// WEBPACK FOOTER //
// ./src/services/authAdminService.ts